export default __webpack_public_path__ + "static/media/back.3b969d70.svg";